const ReviewIcon = ({ size = 56, className = "", isActive = false, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {/* Outer Circle */}
      <rect
        x="1"
        y="1"
        width="54"
        height="54"
        rx="27"
        fill={isActive ? "#68D7FF" : "#9EA6B2"}
        fillOpacity={isActive ? 0.2 : 0.3}
      />
      <rect
        x="1"
        y="1"
        width="54"
        height="54"
        rx="27"
        stroke={`url(#${isActive ? "blue-gradient" : "white-gradient"})`}
        strokeWidth="2"
      />

      {/* Icon Paths - Shared Geometry */}
      <g clipPath="url(#clip0)">
        {/* Chat Bubble Path */}
        <path
          d="M34.7707 24.8476L33.2425 25.4938C33.0457 25.5773 32.8389 25.6195 32.6282 25.6195C32.1767 25.6195 31.7398 25.42 31.4308 25.0722C31.1233 24.7268 30.9645 24.2574 30.9962 23.7848L31.1116 22.0643L30.0513 20.7444C29.8158 20.4509 29.6981 20.0918 29.6818 19.7237H19.6335C17.8133 19.7237 16.3261 21.2803 16.3261 23.1937V32.8417C16.3261 34.755 17.8133 36.3036 19.6335 36.3036H22.1508L22.0966 37.917C22.0811 38.5737 22.4141 39.1736 22.9718 39.4817C23.2119 39.6114 23.4675 39.6763 23.7309 39.6763C24.0717 39.6763 24.4125 39.5547 24.6991 39.3277L28.5409 36.3036H32.9714C34.7916 36.3036 36.2787 34.755 36.2787 32.8417V25.4857L34.7707 24.8476ZM26.6874 30.5878H22.6217C22.2368 30.5878 21.9246 30.261 21.9246 29.8581C21.9246 29.4551 22.2368 29.1284 22.6217 29.1284H26.6874C27.0723 29.1284 27.3845 29.4551 27.3845 29.8581C27.3845 30.261 27.0723 30.5878 26.6874 30.5878ZM30.2914 26.9021H22.6233C22.2383 26.9021 21.9262 26.5754 21.9262 26.1724C21.9262 25.7695 22.2383 25.4427 22.6233 25.4427H30.2914C30.6763 25.4427 30.9885 25.7695 30.9885 26.1724C30.9885 26.5754 30.6763 26.9021 30.2914 26.9021Z"
          fill={isActive ? "#01BBFE" : "white"}
        />
        {/* Star Path */}
        <path
          d="M35.3363 17.2201L36.4986 18.9481L38.6267 19.4406C38.9797 19.5225 39.1185 19.919 38.885 20.1783L37.4749 21.7386L37.6281 23.7705C37.6537 24.1073 37.2904 24.3532 36.9527 24.2265L34.9192 23.4628L32.8858 24.2265C32.5489 24.3532 32.1847 24.1081 32.2104 23.7705L32.3636 21.7386L30.9534 20.1783C30.7192 19.9197 30.8588 19.5225 31.2117 19.4406L33.3398 18.9481L34.5021 17.2201C34.6938 16.9332 35.1438 16.9332 35.3363 17.2201Z"
          fill={isActive ? "#01BBFE" : "white"}
        />
      </g>

      {/* Gradient + ClipPath */}
      <defs>
        <linearGradient
          id="blue-gradient"
          x1="4.23868"
          y1="4.40429"
          x2="51.0494"
          y2="54.4557"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#68D7FF" />
          <stop offset="1" stopColor="#68D7FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="white-gradient"
          x1="3.95297"
          y1="4.40429"
          x2="50.7637"
          y2="54.4557"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" transform="translate(16 16)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ReviewIcon;
